import { createTransform } from "redux-persist";

const clearResolvedAccessState = (state, overrides = {}) => ({
  ...state,
  role: "undefined",
  clientId: null,
  businessId: null,
  allowedBusinessIds: null,
  capabilities: null,
  authBypassed: false,
  accessContextReady: false,
  ...overrides,
});

export const sanitizePersistedAuthState = (state) => {
  if (!state || typeof state !== "object") {
    return state;
  }

  const authBypassed = Boolean(state.authBypassed);

  if (!state.token) {
    return clearResolvedAccessState(state, {
      isAuth: false,
      token: null,
      refreshToken: null,
      refreshTokenExpiresIn: null,
      expires: null,
      userloginid: null,
      id: null,
      user: null,
      email: null,
      authBypassed,
    });
  }

  return clearResolvedAccessState(state, {
    authBypassed,
  });
};

const authAccessTransform = createTransform(
  (inboundState) => sanitizePersistedAuthState(inboundState),
  (outboundState) => sanitizePersistedAuthState(outboundState),
  { whitelist: ["auth"] }
);

export default authAccessTransform;
